import { createTheme } from '@mui/material/styles';
import { baseTheme } from '@tourtask/ui/theme/baseTheme';

const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette, // brand primary from the shared SSOT
    mode: 'light',
    background: {
      default: '#fafafa',
    },
    menu: {
      text: {
        default: '#6c86af',
        hover: '#5b7cb1',
        selected: '#1976d2',
        selectedHover: '#115293',
      },
      background: {
        default: '#fff',
        hover: '#edf0f5',
        selected: '#e3f2fd',
        selectedHover: '#bbdefb',
      }
    }
  }
});

export default lightTheme;